import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  { id: "name", label: "Estimator / Owner Name", type: "text", placeholder: "John Miller" },
  { id: "shop_name", label: "Collision Center Name", type: "text", placeholder: "Northline Auto Body" },
  { id: "email", label: "Shop Business Email", type: "email", placeholder: "john@northlineautobody.com" },
  { id: "phone", label: "Direct Phone Number", type: "tel", placeholder: "(555) 234-5678" },
];

const InterestForm = () => {
  const [values, setValues] = useState({ name: "", shop_name: "", email: "", phone: "" });
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/interest`, values);
      setSent(true);
    } catch (err) {
      toast.error("Submission failed — please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="interest-form"
      data-testid="interest-form-section"
      className="py-20 sm:py-28 bg-[#FAF8F5]"
    >
      <div className="max-w-xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <span className="text-xs font-bold uppercase tracking-widest text-[#9A3412]">
            Early Cohort
          </span>
          <h2 className="text-3xl sm:text-4xl font-normal text-stone-900 font-serif-display mt-2">
            Stop eating short pays.
          </h2>
          <p className="text-sm text-stone-600 mt-3">
            Request Brim for your shop. We onboard a limited number of collision
            repair facilities each month.
          </p>
        </div>

        <div className="bg-white rounded-lg border border-stone-300 p-8 shadow-sm">
          {sent ? (
            <div
              data-testid="interest-success-message"
              className="flex flex-col items-center text-center py-6 space-y-2"
            >
              <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mb-2">
                <svg className="w-5 h-5 text-emerald-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="text-xl font-bold text-stone-900 font-serif-display">
                Application Received
              </div>
              <p className="text-xs text-stone-600 max-w-xs">
                Your shop has been placed in the early access queue. Our
                integration specialist will reach out shortly.
              </p>
            </div>
          ) : (
            <form data-testid="interest-form" onSubmit={onSubmit} className="space-y-4">
              {FIELDS.map((f) => (
                <div key={f.id}>
                  <Label
                    htmlFor={`interest-${f.id}`}
                    className="block text-xs font-mono-ui uppercase text-stone-700 mb-1"
                  >
                    {f.label}
                  </Label>
                  <Input
                    id={`interest-${f.id}`}
                    data-testid={`interest-input-${f.id.replace("_", "-")}`}
                    required
                    type={f.type}
                    placeholder={f.placeholder}
                    value={values[f.id]}
                    onChange={(e) => setValues({ ...values, [f.id]: e.target.value })}
                    className="w-full rounded border-stone-300 text-sm focus-visible:ring-stone-900"
                  />
                </div>
              ))}
              <Button
                type="submit"
                data-testid="interest-submit-btn"
                disabled={submitting}
                className="w-full py-3.5 h-auto text-xs font-bold uppercase tracking-widest text-white bg-[#1C1917] hover:bg-stone-800 rounded transition-colors mt-2"
              >
                {submitting ? "Submitting…" : "Submit Shop Interest"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default InterestForm;
